import { useAppDispatch } from "../../redux";
import { loadPrenotationList, updateOrder, updateOrderAs, updatePage } from "../../redux/reducer/prenotationReducer"
import TableHeaderCell from "../common/table/tableHeaderCell"
import { useSelector } from "react-redux";

const TableHeader = () => {
  const dispatch = useAppDispatch();
  const OnClickOrder = async (orderType: string) => {
    let orderOption = order;
    let listOrderAs = orderAs;
    if (orderType !== orderOption) {
      listOrderAs = "";
    }
    if (listOrderAs === "") {
      orderOption = orderType;
      listOrderAs = "asc"
    }
    else {
      if (orderAs === "asc") {
        listOrderAs = "desc"
      }
      else {
        orderOption = "";
        listOrderAs = ""
      }
    }

    dispatch(updateOrder(orderOption))
    dispatch(updateOrderAs(listOrderAs))
    dispatch(updatePage(1))
    dispatch(loadPrenotationList())
  }

  const { order } = useSelector((state: any) => state.prenotation);
  const { orderAs } = useSelector((state: any) => state.prenotation);

  const getIcon = (orderType: String) => {
    let icon = "unfold_more";

    if (order === orderType) {
      if (orderAs === "desc") {
        icon = "keyboard_arrow_up"
      }
      else {
        icon = "keyboard_arrow_down"
      }
    }
    return icon;
  }

  return (
    <thead>
      <tr>
        <TableHeaderCell label="Codice Prenotazione" />
        <TableHeaderCell icon={getIcon("name")} onClickOrder={() => { OnClickOrder("name") }} label="Nome" />
        <TableHeaderCell icon={getIcon("surname")} onClickOrder={() => { OnClickOrder("surname") }} label="Cognome" />
        <TableHeaderCell icon={getIcon("email")} onClickOrder={() => { OnClickOrder("email") }} label="Email" />
        <TableHeaderCell icon={getIcon("timeslot.startDate")} onClickOrder={() => { OnClickOrder("timeslot.startDate") }} colSpan={2} label="Data e ora" />
        <TableHeaderCell icon={getIcon("timeslot.category")} onClickOrder={() => { OnClickOrder("timeslot.category") }} label="Servizio" />
        <TableHeaderCell label="Prenotazione effetuata da" />
        <TableHeaderCell label="Azioni" align="right" />
      </tr>
    </thead>
  )
}

export default TableHeader